import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Modal from 'components/Modal';
import ThemeButton from 'components/shared/ThemeButton';
import TimeSeriesModalItem from './TimeSeriesModalItem';

const modalStyles = {
  content: {
    position: 'absolute',
    width: '300px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
};
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.white,
    outline: '0',
    borderRadius: '4px',
    padding: '4px',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  itemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '1rem'
  }
}));

const ActiveTimeSeriesModal = ({ items, isOpen, onClose, onSubmit }) => {
  const classes = useStyles();
  const [activeItems, setActiveItems] = useState(items);

  const handleItemChecked = (item, index) => {
    const updatedItems = [...activeItems];
    updatedItems[index] = item;
    setActiveItems(updatedItems);
  };
  const handleSubmit = () => {
    onSubmit(activeItems);
  };

  const renderListItems = () => {
    return activeItems.map((item, index) => (
      <TimeSeriesModalItem
        key={item.label}
        item={item}
        index={index}
        onChecked={handleItemChecked}
      />
    ));
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose} styles={modalStyles}>
      <div className={classes.root}>
        <div className={classes.itemsContainer}>{renderListItems()}</div>
        <ThemeButton themeColor="accent" onClick={handleSubmit}>
          Confirm Time Series
        </ThemeButton>
      </div>
    </Modal>
  );
};

ActiveTimeSeriesModal.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired
    }).isRequired
  ).isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

ActiveTimeSeriesModal.defaultProps = {
  isOpen: false
};

export default ActiveTimeSeriesModal;
